<template>
    <a-modal
        :title="dataInfo.id ? $t('goods.edit_jieti_sales' /*编辑阶梯促销 */) : $t('goods.add_jieti_sales' /*添加阶梯促销 */)"
        :visible="visible"
        :confirm-loading="confirmLoading"
        :bodyStyle="{
            height: '650px',
            overflow: 'auto'
        }"
        :width="900"
        @cancel="handleCancel"
        @ok="handleSubmit"
    >
        <div>
            <div class="setting">
                <div class="title mb20">{{ $t('goods.activity_info' /*活动信息 */) }}</div>
                <a-form :form="form" :layout="'vertical'" class="pl10 pr10">
                    <a-row :gutter="[10, 10]">
                        <a-col :xs="24" :sm="12">
                            <a-form-item :label="$t('goods.promotion_name' /*促销活动名称 */)">
                                <a-input
                                    v-decorator="['name', { rules: [{ required: true, message: $t('formConfig.please_enter' /* 请输入 */) + $t('goods.promotion_name' /*促销活动名称 */) }] }]"
                                    :placeholder="$t('formConfig.please_enter' /* 请输入 */) + $t('goods.promotion_name' /*促销活动名称 */)"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :xs="24" :sm="12">
                            <a-form-item :label="$t('goods.start_end_time' /*起止时间 */)">
                                <a-range-picker
                                    show-time
                                    v-decorator="['time', { rules: [{ required: true, message: $t('formConfig.please_select' /* 请选择 */) + $t('goods.start_end_time' /*起止时间 */) }] }]"
                                    @change="handleChangeTime"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </div>

            <!-- 门票信息 -->
            <div class="goods-discount mt20">
                <div class="title strong mb20 fs18">{{ $t('goods.ticket_info' /*门票信息 */) }}</div>
                <a-table ref="table" :rowKey="record => record.id" :columns="columns1" :data-source="dataSource1" :pagination="false" class="mt15" size="middle">
                    <span slot="index" slot-scope="text, record, index">
                        {{ index + 1 }}
                    </span>
                    <span slot="status" slot-scope="text">
                        <a-badge :status="text | statusTypeFilter" :text="text | statusFilter(that)" />
                    </span>

                    <span slot="inventory" slot-scope="text, record">
                        {{ record.is_limit == 0 ? $t('goods.unlimited' /* 不限 */) : text }}
                    </span>

                    <span slot="action" slot-scope="text, record">
                        <a-input-number style="width: 100px" v-model="record.promo_price" :precision="2" :min="0" :placeholder="$t('goods.enter_discount_price' /* 请填写优惠后价格 */)" />
                        {{ $t('goods.yuan' /* 元 */) }}
                        <a-button type="danger" size="small" class="ml10" @click="removeTicket(record)">{{ $t('web.delete' /* 删除 */) }}</a-button>
                    </span>
                </a-table>
                <a-button type="dashed mt10 add-event-box" style="width: 100%" @click="showTicketSelectionModal">
                    <a-icon type="plus-circle" />
                    {{ $t('goods.select_ticket' /* 选择门票 */) }}
                </a-button>
            </div>

            <!-- 选择促销门票弹窗 -->
            <a-modal
                :title="$t('goods.select_promotion_ticket' /*选择促销门票 */)"
                :visible="ticketSelectionVisible"
                :width="800"
                @ok="confirmTicketSelection"
                @cancel="handleCancelTicketSelection"
                :bodyStyle="{
                    height: '600px',
                    overflow: 'auto'
                }"
            >
                <a-form :layout="'vertical'" class="pl10 pr10">
                    <a-row :gutter="[10, 10]">
                        <a-col :span="9">
                            <a-form-item label="">
                                <a-input v-model="searchParams.goods_name" :placeholder="$t('formConfig.please_enter' /* 请输入 */) + $t('goods.ticket_name' /* 门票名称 */)" allowClear />
                            </a-form-item>
                        </a-col>
                        <a-col :span="9">
                            <a-form-item label="">
                                <a-select v-model="searchParams.status" :placeholder="$t('goods.please_select_ticket_status' /* 请选择门票状态 */)" allowClear>
                                    <a-select-option v-for="(item, index) in statusList" :key="index" :value="item.value">
                                        {{ item.label }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-button type="primary" class="mt4" style="width: 80px" @click="getGoodsList">{{ $t('web.query' /* 查询 */) }}</a-button>
                        </a-col>
                    </a-row>
                </a-form>
                <a-table
                    ref="selectTable"
                    :rowKey="record => record.id"
                    :columns="columns"
                    :data-source="dataSource"
                    :pagination="pagination"
                    :loading="loading"
                    :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                    class="mt15"
                    size="middle"
                    @change="getGoodsList"
                >
                    <span slot="index" slot-scope="text, record, index">
                        {{ index + 1 }}
                    </span>
                    <span slot="status" slot-scope="text">
                        <a-badge :status="text | statusTypeFilter" :text="text | statusFilter(that)" />
                    </span>

                    <span slot="inventory" slot-scope="text, record">
                        {{ record.is_limit == 0 ? $t('goods.unlimited' /* 不限 */) : text }}
                    </span>
                </a-table>
            </a-modal>
        </div>
    </a-modal>
</template>

<script>
const statusTypeFilter = {
    1: 'success',
    0: 'error'
};

const fields = ['name', 'time', 'start_time', 'end_time'];
import pick from 'lodash.pick';
import moment from 'moment';
export default {
    name: 'simplified-promotion',
    props: {
        dataInfo: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            confirmLoading: false,
            form: this.$form.createForm(this),
            ticketSelectionVisible: false,
            statusList: [
                { label: this.$t('goods.put_away' /* 上架 */), value: 1 },
                { label: this.$t('goods.sold_out' /* 下架 */), value: 0 }
            ], // 门票状态
            columns: [
                {
                    title: this.$t('goods.index' /* 序号 */),
                    align: 'center',
                    scopedSlots: { customRender: 'index' },
                    width: 80
                },
                {
                    title: this.$t('goods.ticket_name' /* 门票名称 */),
                    dataIndex: 'name',
                    align: 'center'
                },
                {
                    title: this.$t('goods.ticket_status' /* 门票状态 */),
                    dataIndex: 'status',
                    align: 'center',
                    scopedSlots: { customRender: 'status' },
                    width: 80
                },
                {
                    title: this.$t('goods.ticket_num' /* 门票编号 */),
                    dataIndex: 'number',
                    align: 'center',
                    width: 120
                },
                {
                    title: this.$t('goods.inventory' /* 库存 */),
                    dataIndex: 'inventory',
                    align: 'center',
                    scopedSlots: { customRender: 'inventory' },
                    width: 100
                }
            ],
            dataSource: [],
            pagination: {
                current: 1,
                pageSize: 100,
                pageSizeOptions: ['100']
            },
            // 促销门票搜索
            searchParams: {},
            selectedRowKeys: [], // 选中的门票
            tempSelectedRows: [],
            //门票优惠设置表格数据
            dataSource1: [],
            columns1: [
                {
                    title: this.$t('goods.index' /* 序号 */),
                    dataIndex: 'index',
                    align: 'center',
                    scopedSlots: { customRender: 'index' },
                    width: 80
                },
                {
                    title: this.$t('goods.ticket_name' /* 门票名称 */),
                    dataIndex: 'name',
                    align: 'center'
                },
                {
                    title: this.$t('goods.price' /* 单价 */),
                    dataIndex: 'price',
                    align: 'center',
                    width: 100
                },
                {
                    title: this.$t('goods.ticket_num' /* 门票编号 */),
                    dataIndex: 'number',
                    align: 'center',
                    width: 80
                },
                {
                    title: this.$t('goods.inventory' /* 库存 */),
                    dataIndex: 'inventory',
                    align: 'center',
                    scopedSlots: { customRender: 'inventory' },
                    width: 90
                },
                {
                    title: this.$t('goods.discounted_price' /* 优惠后价格 */),
                    dataIndex: 'action',
                    align: 'center',
                    scopedSlots: { customRender: 'action' },
                    width: 250
                }
            ],
            loading: false,
            that: this
        };
    },
    filters: {
        statusTypeFilter(value) {
            return statusTypeFilter[value];
        },
        statusFilter(value, vm) {
            const obj = {
                1: vm.$t('goods.put_away' /* 上架 */),
                0: vm.$t('goods.sold_out' /* 下架 */)
            };
            return obj[value];
        }
    },
    watch: {
        visible(val) {
            if (val) {
                fields.forEach(v => this.form.getFieldDecorator(v));
                if (this.dataInfo.id) {
                    this.form.getFieldDecorator('id', { initialValue: this.dataInfo.id, preserve: true });
                    this.dataInfo.time = [moment(this.dataInfo.start_time), moment(this.dataInfo.end_time)];
                    this.form.setFieldsValue(pick(this.dataInfo, fields));
                    this.form.getFieldDecorator('start_time', { initialValue: this.dataInfo.start_time, preserve: true });
                    this.form.getFieldDecorator('end_time', { initialValue: this.dataInfo.end_time, preserve: true });
                    this.dataInfo.goods.forEach(item => {
                        item.id = item.goods_id;
                    }); //id  使用门票id，和步骤二一致
                    this.dataSource1 = this.dataInfo.goods;
                    // this.selectedRowKeys = this.dataInfo.goods.map(item => item.goods_id);
                }
            }
        }
    },
    methods: {
        handleChangeTime(date, dateString) {
            this.form.setFieldsValue({
                start_time: dateString[0],
                end_time: dateString[1]
            });
        },
        handleCancel() {
            this.close();
            this.$emit('cancel');
        },
        showTicketSelectionModal() {
            // Validate form first
            this.form.validateFields((err, values) => {
                if (err) {
                    return;
                }

                if (values.time) {
                    values.start_time = values.time[0].format('YYYY-MM-DD HH:mm:ss');
                    values.end_time = values.time[1].format('YYYY-MM-DD HH:mm:ss');
                    this.form.getFieldDecorator('start_time', { initialValue: values.start_time, preserve: true });
                    this.form.getFieldDecorator('end_time', { initialValue: values.end_time, preserve: true });
                }

                this.ticketSelectionVisible = true;
                this.getGoodsList();
            });
        },
        // 选择促销门票关闭
        handleCancelTicketSelection() {
            this.ticketSelectionVisible = false;
            this.selectedRowKeys = [];
            this.tempSelectedRows = [];
        },
        // 选择促销门票
        confirmTicketSelection() {
            if (this.tempSelectedRows.length === 0) {
                this.$message.warning(this.$t('formConfig.please_select' /* 请选择 */) + this.$t('goods.ticket_label' /* 门票 */));
                return;
            }

            // Add selected tickets to the main table
            const newTickets = this.tempSelectedRows.filter(ticket => !this.dataSource1.some(existingTicket => existingTicket.id === ticket.id));
            this.dataSource1 = [...this.dataSource1, ...newTickets];
            // 如果 this.dataInfo.goods 有选中的门票id，需要把 this.dataInfo.goods 中的promo_price数据赋值给 this.dataSource1
            if (this.dataInfo.goods && this.dataInfo.goods.length > 0) {
                this.dataInfo.goods.forEach(item => {
                    let index = this.dataSource1.findIndex(v => v.id == item.goods_id);
                    if (index > -1) {
                        this.dataSource1[index].promo_price = item.promo_price;
                    }
                });
            }
            this.ticketSelectionVisible = false;
            this.tempSelectedRows = [];
            this.selectedRowKeys = [];
        },
        removeTicket(record) {
            this.dataSource1 = this.dataSource1.filter(item => item.id !== record.id);
        },
        // 获取门票列表
        getGoodsList() {
            // if(this.dataSource.length > 0 && !this.searchParams.goods_name && this.searchParams.status === undefined){
            //     return;
            // }

            let data = {
                page: this.pagination.current,
                limit: this.pagination.pageSize,
                sale_tiered_time: this.form.getFieldValue('start_time') + '~' + this.form.getFieldValue('end_time'),
                not_sale_tiered_id: this.dataInfo.id || '',
                ...this.searchParams
            };
            this.loading = true;
            this.$request.get({ url: 'getGoodsList', data }).then(res => {
                this.pagination.total = parseInt(res.data.total);
                let dataList = res.data.data;
                let resultData = dataList.filter(dItem => {
                    return !this.dataSource1.some(item => item.id === dItem.id);
                });
                this.dataSource = resultData;
                this.loading = false;
            });
        },
        // 选中门票
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys;
            this.tempSelectedRows = selectedRows;
        },
        handleSubmit() {
            this.form.validateFields((err, values) => {
                if (err) {
                    return;
                }

                // Check if all tickets have promo_price
                const missingPriceTickets = this.dataSource1.filter(item => !item.promo_price);
                if (missingPriceTickets.length > 0) {
                    this.$message.error(this.$t('goods.please_set_discount_price' /* 请为每个门票设置优惠价格 */));
                    return;
                }

                // Format data for submission
                values.start_time = values.time[0].format('YYYY-MM-DD HH:mm:ss');
                values.end_time = values.time[1].format('YYYY-MM-DD HH:mm:ss');
                delete values.time;

                const goodsList = this.dataSource1.map(item => ({
                    goods_id: item.id.toString(),
                    promo_price: String(item.promo_price)
                }));

                const data = {
                    ...values,
                    goodsList
                };

                this.$request.post({ url: 'tieredCreateUpdate', data }).then(res => {
                    this.$message.success(this.$t('web.operate_scuuess' /* 操作成功 */));
                    this.close();
                    this.$emit('ok');
                });
            });
        },
        close() {
            // Reset all form fields
            this.form.resetFields(['id']);
            this.form.getFieldDecorator('id', { initialValue: '', preserve: true });
            this.form.resetFields();

            // Reset data
            this.dataSource = [];
            this.dataSource1 = [];
            this.searchParams = {};
            this.selectedRowKeys = [];
            this.tempSelectedRows = [];
        }
    }
};
</script>

<style scoped lang="less">
/deep/ .ant-form-item {
    margin-bottom: 0;
}
.ml10 {
    margin-left: 10px;
}
.mt20 {
    margin-top: 20px;
}
.mb20 {
    margin-bottom: 20px;
}
</style>
